<template>
  <div class="FormLabelBlock mb-2">
    <slot></slot>
  </div>
</template>

<script>
  export default {}
</script>

<style lang="scss"
       type="text/scss">
  .FormLabelBlock {
    color: rgba(0, 0, 0, 0.87);
    font-size: 20px;
    font-weight: 700;
  }
</style>
